import React from 'react';
import { Form } from 'semantic-ui-react';
import Competitions from './Competitions';
import { withNamespaces } from 'react-i18next';
import { map, filter, pipe, pick } from 'ramda';


const Competition = (props) => {
  const {
    onEventUpdate,
    onCompetitionUpdate,
    events = [],
    event,
    competition,
    workshopId,
    t
  } = props;

  const filteredWorkshops = pipe(
    filter(e => !!e.registrationEnabled && e.type === 'WORKSHOP'),
    map((e) => pick(['text', 'value'], e))
  )(events);
  
  return (
    <div>
      <Form.Group>
        {workshopId && <Form.Input
                         disabled={true}
                         width={6}
                         fluid
                         label={t('private:addWorkshop.event')}
                         value={event.title}/>}
        {!workshopId && <Form.Dropdown
                          required
                          width={6}
                          fluid
                          selection
                          label={t('private:addWorkshop.event')}
                          placeholder={t('private:addWorkshop.event_i')}
                          name={event.id}
                          value={event.id}
                          options={filteredWorkshops}
                          onChange={onEventUpdate} />}
      </Form.Group>
      <Competitions
        events={events}
        disabled={!!workshopId}
        activeEventId={event.id}
        activeCompetitionId={competition.id}
        onSelect={onCompetitionUpdate}
      />
    </div>
  );
};

export default withNamespaces('private')(Competition);



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Form/Competition/index.js